import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formValueSelector, initialize, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { isValidEmail } from 'redux/modules/billing';
var StripeACHBillingForm = (_dec = reduxForm({
  form: 'billing'
}), _dec2 = connect(function (state) {
  var billingFormSelector = formValueSelector('billing');
  return {
    active: state.form.billing.active,
    contract: state.contract,
    billingError: state.billing.billingError,
    showMonthsPaidFor: billingFormSelector(state, 'showMonthsPaidFor'),
    monthsPaidFor: billingFormSelector(state, 'monthsPaidFor')
  };
}, {
  initialize: initialize
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(StripeACHBillingForm, _Component);

  var _super = _createSuper(StripeACHBillingForm);

  function StripeACHBillingForm() {
    var _this;

    _classCallCheck(this, StripeACHBillingForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          showAsyncValidating = _ref.showAsyncValidating,
          className = _ref.className,
          styles = _ref.styles,
          stripe = _ref.stripe,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          dirty = _ref$meta.dirty,
          active = _ref$meta.active,
          visited = _ref$meta.visited,
          asyncValidating = _ref$meta.asyncValidating;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-group ".concat(error && touched ? 'has-error' : '')
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: input.name,
        className: "col-sm-2"
      }, label), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-8 ".concat(styles.inputGroup)
      }, showAsyncValidating && asyncValidating && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-cog fa-spin ".concat(styles.cog)
      }), /*#__PURE__*/React.createElement("input", _extends({}, input, {
        type: type,
        className: className,
        id: input.name,
        "data-stripe": stripe
      })), error && touched && /*#__PURE__*/React.createElement("div", {
        className: "text-danger"
      }, error)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSelect", function (_ref2) {
      var input = _ref2.input,
          label = _ref2.label,
          className = _ref2.className,
          styles = _ref2.styles,
          stripe = _ref2.stripe,
          defaultValue = _ref2.defaultValue,
          options = _ref2.options,
          _ref2$meta = _ref2.meta,
          touched = _ref2$meta.touched,
          error = _ref2$meta.error,
          dirty = _ref2$meta.dirty,
          active = _ref2$meta.active,
          visited = _ref2$meta.visited;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-group ".concat(error && touched ? 'has-error' : '')
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: input.name,
        className: "col-sm-2"
      }, label), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-8 ".concat(styles.inputGroup)
      }, /*#__PURE__*/React.createElement("select", _extends({}, input, {
        defaultValue: defaultValue,
        className: className,
        id: input.name,
        "data-stripe": stripe
      }), options.map(function (option, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: index,
          value: option.value
        }, option.text);
      })), error && touched && /*#__PURE__*/React.createElement("div", {
        className: "text-danger"
      }, error)));
    });

    return _this;
  }

  _createClass(StripeACHBillingForm, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.initialize('billing', {
        name: "".concat(this.props.contract.firstName, " ").concat(this.props.contract.lastName),
        currency: 'USD',
        // TODO: Allow for currency selection
        country: 'US',
        // TODO: Allow for country selection
        monthsPaidFor: 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var styles = require('./BillingForm.scss');

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Bank Account Information"), /*#__PURE__*/React.createElement("input", {
        name: "country",
        "data-stripe": "country",
        type: "hidden",
        value: "US"
      }), /*#__PURE__*/React.createElement("input", {
        name: "currency",
        "data-stripe": "currency",
        type: "hidden",
        value: "USD"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "routingNumber",
        component: this.renderInput,
        type: "text",
        label: "Routing Number",
        stripe: "routing_number",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "accountNumber",
        component: this.renderInput,
        type: "text",
        label: "Account Number",
        stripe: "account_number",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "accountHolderName",
        component: this.renderInput,
        type: "text",
        label: "Account Holder Name",
        stripe: "account_holder_name",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "accountHolderType",
        component: this.renderSelect,
        label: "Account Holder Type",
        stripe: "account_holder_type",
        className: "form-control",
        styles: styles,
        value: "company",
        options: [{
          value: 'company',
          text: 'Company'
        }, {
          value: 'individual',
          text: 'Individual'
        }]
      }));
    }
  }]);

  return StripeACHBillingForm;
}(Component), _defineProperty(_class2, "propTypes", {
  initialize: PropTypes.func.isRequired
}), _temp)) || _class) || _class);
export { StripeACHBillingForm as default };